export var SET_NOTIFICATION_BANNER = 'SET_NOTIFICATION_BANNER';